import { Button } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function FilledButton({
  children,
  green,
  to,
  onClick,
  outline,
  disabled,
  selected,
  label,
  name,
  loading,
}) {
  const navigate = useNavigate();
  const [selfDisabled, setSelfDisabled] = useState(false);
  const [selfLoading, setSelfLoading] = useState(false);

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (!selfDisabled && !disabled) {
      setSelfDisabled(true);
      if (loading) setSelfLoading(true);
      onClick(() => {
        setSelfDisabled(false);
        setSelfLoading(false);
      });
    }
  };

  return (
    <>
      {!!label && (
        <label
          className="text-sm"
          style={{ color: "var(--color-2-text)" }}
          htmlFor={name}
        >
          {label}
        </label>
      )}
      <Button
        ref={(node) =>
          node && node.style.setProperty("padding-top", "3.3px", "important")
        }
        loading={selfLoading}
        disabled={disabled || selfDisabled || selfLoading}
        size="large"
        className="text-bold text-sm button-padding"
        type={outline && !selected ? "default" : green ? "default" : "primary"}
        style={{
          display: "flex",
          alignItems: "center",
          borderRadius: 5,
          marginTop: !!label && 6,
          ...(green && {
            borderColor: "var(--color-secondary)",
            color: outline ? "var(--color-secondary)" : "white",
            backgroundColor: outline ? "transparent" : "var(--color-secondary)",
          }),
        }}
        onClick={to ? () => navigate(to) : handleClick}
      >
        {children}
      </Button>
    </>
  );
}
